import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export default function AcessoNegado({ mensagem }) {
  const navigate = useNavigate();
  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', py: 10, px: 3,
    }}>
      <Box sx={{
        width: 72, height: 72, borderRadius: '50%', mb: 3,
        backgroundColor: '#fce8ec', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <LockOutlinedIcon sx={{ fontSize: 32, color: '#e94560' }} />
      </Box>
      <Typography variant="h6" fontWeight={700} sx={{ color: '#1a1a2e', mb: 1 }}>
        Acesso negado
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380, mb: 3 }}>
        {mensagem || 'Você não tem acesso a esta página no momento.'}
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')} sx={{ backgroundColor: '#13375F' }}>
        Voltar ao início
      </Button>
    </Box>
  );
}